import { useState, useEffect } from 'react';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '热播榜单', href: '#ranking' },
  { label: '新片速递', href: '#updates' },
  { label: '极速播放', href: '#features' },
  { label: '热门电影', href: '#cards' },
  { label: '联系我们', href: '#contact' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-[64px] md:h-[72px]">
          <a
            href="#hero"
            className="flex items-center gap-2 group"
          >
            <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-accent-500">
              <i className="ri-film-line text-lg md:text-xl text-foreground-950"></i>
            </div>
            <span
              className={`font-heading text-lg md:text-xl font-bold whitespace-nowrap transition-colors ${
                scrolled ? 'text-foreground-50' : 'text-foreground-950'
              }`}
            >
              无极电影网
            </span>
          </a>

          <div className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className={`px-4 py-2 text-sm font-medium rounded-full whitespace-nowrap transition-all duration-200 cursor-pointer ${
                  scrolled
                    ? 'text-foreground-100 hover:text-primary-600 hover:bg-primary-50'
                    : 'text-foreground-800/90 hover:text-foreground-950 hover:bg-foreground-950/10'
                }`}
              >
                {item.label}
              </a>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className="px-4 py-2 text-sm font-medium whitespace-nowrap rounded-full border cursor-pointer transition-all duration-200 border-primary-500/30 text-primary-500 hover:bg-primary-500 hover:text-foreground-950">
              <i className="ri-search-line mr-1.5"></i>
              搜片
            </button>
            <a
              href="#app"
              className="px-5 py-2 text-sm font-semibold whitespace-nowrap rounded-full cursor-pointer transition-all duration-200 bg-primary-500 text-foreground-950 hover:bg-primary-600"
            >
              免费观影
            </a>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer transition-colors"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i
              className={`text-xl transition-colors ${
                scrolled ? 'text-foreground-100' : 'text-foreground-950'
              } ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}
            ></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden pb-4 border-t border-background-200/40">
            <div className="flex flex-col gap-1 pt-3">
              {navItems.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={() => setMobileOpen(false)}
                  className="px-4 py-2.5 text-sm font-medium text-foreground-100 rounded-lg hover:bg-background-100 whitespace-nowrap cursor-pointer transition-colors"
                >
                  {item.label}
                </a>
              ))}
              <div className="flex gap-2 px-4 pt-2">
                <button className="flex-1 px-4 py-2 text-sm font-medium whitespace-nowrap rounded-full border border-primary-500/30 text-primary-500 cursor-pointer transition-colors">
                  搜片
                </button>
                <a
                  href="#app"
                  onClick={() => setMobileOpen(false)}
                  className="flex-1 px-4 py-2 text-sm font-semibold whitespace-nowrap rounded-full text-center bg-primary-500 text-foreground-950 cursor-pointer transition-colors"
                >
                  免费观影
                </a>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}